export const EMPTY_DATA_SEARCH_RELEASE_NOTE = {
    text_search: '',
    release_at: null,
};
